module.exports = __webpack_public_path__ + "media/images/webpage/logo/logo-icotto-white-b07f5b8281daf5b1c0d8ba7f9f463910.svg";